export const SET_STATE = 'checkoutPage/booking/SET_STATE';
export const SET_FETCHING_BOOKING_VERIFY = 'checkoutPage/booking/SET_FETCHING_BOOKING_VERIFY';
export const SET_FETCHING_BOOKING_CREATE = 'checkoutPage/booking/SET_FETCHING_BOOKING_CREATE';
export const SET_BOOKING_VERIFY_VALUE = 'checkoutPage/booking/SET_BOOKING_VERIFY_VALUE';
export const SET_BOOKING_CREATE_VALUE = 'checkoutPage/booking/SET_BOOKING_CREATE_VALUE';
export const RESET_BOOKING_VERIFY = 'checkoutPage/booking/RESET_BOOKING_VERIFY';
export const RESET_BOOKING_CREATE = 'checkoutPage/booking/RESET_BOOKING_CREATE';
export const RESET_STATE = 'checkoutPage/booking/RESET_STATE';
